import { useEffect, useState } from "react";

/**
 * Eski arayuzun 760px kirilim noktasi (frontend/public/css/style.css)
 * masaustu yan/ust sekmeler ↔ mobil alt gezinme cubugu gecisini belirler.
 * jsdom'da CSS medya sorgulari uygulanmadigindan Layout bu hook'la JS
 * seviyesinde dallanir (testlerde matchMedia stub'lanabilir).
 */
export function useIsMobile(breakpointPx = 760): boolean {
  const query = `(max-width: ${breakpointPx - 1}px)`;

  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    setIsMobile(mql.matches);

    const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }
    // eski Safari fallback
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, [query]);

  return isMobile;
}
